const extendConstants = (...constants) => {
    constants.forEach(constant => {
        Object.keys(constant).forEach(key => (constant[constant[key]] = key));
    });
};

export const shadingType = {
    SMOOTH: 0,
    FLAT: 1,
};
export const colorType = {
    BUFFER:             0,
    TEXTURE_UV:         1,
    TEXTURE_PROJECTION: 2,
    DISTANCE_MAP:       3,
    MATCAP:             4,
    UNIFORM:            5,
};
export const lineType = {
    SCREEN: 0,
    INSTANCED: 1,
    GENERAL: 2,
};
export const lineColorType = {
    UNIFORM: 0,
    TEXTURE: 1,
    OUTPUT: 2,
    BUFFER: 3,
};
export const stepType = {
    NONE:           0,
    SELECT:         1,
    SMOOTH:         2,
    ERASE:          3,
    TRANSFORM:      4,
    DEFEATURE:      5,
    HEAL_TEXTURE:   6,
    CUSTOM:         7,
};
export const msgType = {
    LOAD_PROJECT                 : 0,
    ERASE                        : 2,
    SELECT                       : 3,
    SMOOTH                       : 4,
    SET_OBJECT_TRANSFORM         : 10,
    SET_OBJECT_VISIBILITY        : 11,
    SET_OBJECT_NAME              : 12,
    SET_OBJECT_COLOR             : 13,
    GROUP_OBJECTS                : 15,
    ADD_OBJECT_TO_GROUP          : 16,
    REMOVE_OBJECT_FROM_GROUP     : 17,
    REMOVE_GROUP                 : 18,
    CLEAR_SELECTION              : 19,
    DUPLICATE_OBJECT             : 21,
    SAVE                         : 22,
    UNDO                         : 23,
    REDO                         : 24,
    CLEANUP                      : 27,
    INVERT_SELECTION             : 29,
    SET_OBJECT_LOCK_STATE        : 30,
    INIT                         : 31,
    UPDATE_PROJECT               : 37,
    RESET_HISTORY                : 38,
    ADJUST_TEXTURE               : 39,
    INVERT_NORMALS               : 40,
    REMOVE_OBJECT                : 41,
};
export const propertyType = {
    OBJECT  : 1,
    FRAME   : 2,
    GROUP   : 3,
    ASSET   : 4,
    LEVEL   : 5,
    MEASURE : 6,
    PHOTO_GROUP: 7,
};
export const objectType = {
    ANONYM              : 0,
    SCAN                : 1,
    FUSION              : 2,
    SURFELS             : 3,
    GROUP               : 4,
    CAD                 : 6,
    POINTCLOUD          : 7,
    PHOTO_GROUP         : 8,
    LINEAR_MEASURE      : 9,
    GEODESIC_MEASURE    : 10,
    SECTION             : 11,
    DISTANCE_MAP        : 12,
};
export const cadType = {
    MODEL : 1,
    CYLINDER : 2,
    CONE: 3,
    TRUNCATED_CONE: 4,
    SPHERE: 5,
    PLANE: 6,
    TORUS: 7,
    FREEFORM: 8,
    UNDEFINED: 9,
};
export const basePlane = {
    XOY: 0,
    YOZ: 1,
    ZOX: 2,
};
export const selectionType = {
    NONE          : -1,
    SPHERE        :  0,
    CIRCLE        :  1,
    RECTANGLE     :  2,
    LASSO         :  3,
    CUT_OFF_PLANE :  4,
    INVERT        :  5,
    CLEAR         :  6,
};
export const postEffects = {
    COLOR_BALANCE          : 0,
    SHARPNESS              : 1,
    GRAIN                  : 2,
    VIGNETTE               : 3,
};
export const fittingMode = {
    EXPAND : 0,
    EXACT  : 1,
    ROBUST : 2,
}
export const cadPrimitive = {
    PLANE    : 0,
    SPHERE   : 1,
    TORUS    : 2,
    CYLINDER : 3,
    CONE     : 4,
}
export const photoState = {
    DEFAULT : 0,
    HOVERED : 1,
    ACTIVE  : 2,
}
export const photoOrientation = {
    DEFAULT                         : 0,
    MIRROR_HORIZONTAL               : 1,
    ROTATION180                     : 2,
    MIRROR_VERTICAL                 : 3,
    ROTATION90_MIRROR_HORIZONTAL    : 4,
    ROTATION90                      : 5,
    ROTATION270_MIRROR_HORIZONTAL   : 6,
    ROTATION270                     : 7,
}
export const scanMode = {
    TRIANGLES       : 0,
    SURFELS_HIGH    : 1,
    SURFELS_MID     : 2,
}
export const propertyInitStatus = {
    INCOMPLETE       : 0,
    INITIALIZING     : 1,
    COMPLETE         : 2,
}
extendConstants(msgType);
